var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2308 11.0526V15.7895L18.8462 15.7895L18.8462 14.2105L15.7692 14.2105V11.0526H14.2308Z",
    fill: "#8586A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9231 0H8.11538V7.55638C6.19648 9.42642 5 12.0698 5 15C5 17.9302 6.19648 20.5736 8.11538 22.4436V30H21.9231V22.4059C23.8195 20.5382 25 17.9106 25 15C25 12.0894 23.8195 9.46185 21.9231 7.59406V0ZM9.65385 28.4211V23.6749C11.2001 24.6808 13.0338 25.2632 15 25.2632C16.9825 25.2632 18.8303 24.6711 20.3846 23.6498V28.4211H9.65385ZM20.3846 6.35024V1.57895H9.65385V6.32509C11.2001 5.31923 13.0338 4.73684 15 4.73684C16.9825 4.73684 18.8303 5.32894 20.3846 6.35024ZM6.53846 15C6.53846 10.2038 10.3268 6.31579 15 6.31579C19.6732 6.31579 23.4615 10.2038 23.4615 15C23.4615 19.7962 19.6732 23.6842 15 23.6842C10.3268 23.6842 6.53846 19.7962 6.53846 15Z",
    fill: "#8586A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.e0bfab6aea0b84a45833d00438cb0c34.svg";
export { ForwardRef as ReactComponent };